import { attributeTypes, sanitizeHtml } from 'utils';
import { inputTypeEnums } from '../../formDetail/attributes/constnats';
import React from 'react';

export const PrevInfoLine = ({ item, value }) => {
    const renderValues = () => {
        if (item?.type === attributeTypes.SELECT) {
            if (item?.defaultDateType === 'MULTIPLE') {
                return value?.map((i) => i?.name).join(', ');
            }
            if (item?.defaultDateType === 'SINGLE') {
                return value?.name;
            }
        } else if (item?.type === attributeTypes.INPUT && item?.defaultDateType === inputTypeEnums.TEXT) {
            return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.value) }} />;
        } else {
            return value;
        }
    };

    return (
        <div className="preview-info-line">
            {/*<p className='preview-info-line-title'>{item?.label}</p>*/}
            <div className="preview-info-line-value">{renderValues()}</div>
        </div>
    );
};
